import { axiosApiInstance } from './axios';

const apiRoot = '';

export const tobaccoContainersApi = {
  get: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/web/tobacco-containers/v1/get-all`, { params });
      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getPeriodEnd: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/web/tobacco-containers/v1/get-period-end`, { params });
      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  canDelete: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/web/tobacco-containers/v1/can-delete/${id}`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};
